
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"9","fill":"none","stroke":"currentColor","stroke-width":"1.5"}}),_c('circle',{attrs:{"cx":"12","cy":"5","r":".8","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"12","cy":"19","r":".8","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"5","cy":"12","r":".8","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"19","cy":"12","r":".8","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12 7v5l3 3","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    